import {gsap} from 'gsap';

function initSpoiler() {
  const spoilerSelector = '.js-spoiler';
  const btnSelector = '.js-spoiler-btn';
  const btnTextSelector = '.js-spoiler-btn-text';
  const contentSelector = '.js-spoiler-content';
  const openClass = 'spoiler--open';

  const spoilerList = document.querySelectorAll(spoilerSelector);
  if (!spoilerList.length) return;

  //for partial spoiler
  for (let i = 0; i < spoilerList.length; i++) {
    const spoiler = spoilerList[i];

    const content = spoiler.querySelector(contentSelector);
    if (!content) continue;

    const isOpen = spoiler.classList.contains(openClass);

    if (isOpen) {
      spoiler.classList.remove(openClass);
    }

    content.setAttribute('data-height', content.offsetHeight);

    if (isOpen) {
      spoiler.classList.add(openClass);
    }
  }

  for (let i = 0; i < spoilerList.length; i++) {
    const spoiler = spoilerList[i];

    spoiler.addEventListener('click', (e) => {
      const btn = e.target.closest(btnSelector);
      if (!btn) return;

      e.preventDefault();//maybe link

      const btnText = btn.querySelector(btnTextSelector);

      const content = spoiler.querySelector(contentSelector);
      if (!content) return;

      let height = 0;
      if (content.hasAttribute('data-height')) {
        height = +content.getAttribute('data-height');
      }

      if (spoiler.classList.contains(openClass)) {
        spoiler.classList.remove(openClass);

        if (btn.hasAttribute('data-show-text')) {
          if (btnText) {
            btnText.textContent = btn.getAttribute('data-show-text');
          } else {
            btn.textContent = btn.getAttribute('data-show-text');
          }
        }

        gsap.to(content, {height: height});
      } else {
        spoiler.classList.add(openClass);


        if (btn.hasAttribute('data-hide-text')) {
          if (btnText) {
            btnText.textContent = btn.getAttribute('data-hide-text');
          } else {
            btn.textContent = btn.getAttribute('data-hide-text');
          }
        }

        gsap.set(content, {height: 'auto'});
        gsap.from(content, {height: height});
      }
    });
  }
}

function initCheckSpoiler() {
  const formSelector = '.js-check-spoiler-form';
  const inputSelector = '.js-check-spoiler-input';
  const contentSelector = '.js-check-spoiler-content';
  const openClass = 'spoiler--open';

  const formList = document.querySelectorAll(formSelector);
  if (!formList.length) return;

  function spoilerHandle(input, isAnimate = false) {
    const form = input.closest(formSelector);
    if (!form) return;

    const spoilerSelector = input.getAttribute('data-spoiler-target');
    if (!spoilerSelector) return;

    const spoiler = form.querySelector(spoilerSelector);
    if (!spoiler) return;

    const content = spoiler.querySelector(contentSelector);
    if (!content) return;

    if (input.checked) {
      spoiler.classList.add(openClass);

      gsap.set(content, {height: 'auto'});

      if (isAnimate) {
        gsap.from(content, {height: 0});
      }
    } else {
      spoiler.classList.remove(openClass);

      if (isAnimate) {
        gsap.to(content, {height: 0});
      } else {
        gsap.set(content, {height: 0});
      }
    }
  }

  for (let i = 0; i < formList.length; i++) {
    const form = formList[i];

    const inputList = form.querySelectorAll(inputSelector);

    inputList.forEach(spoilerHandle);

    form.addEventListener('change', (e) => {
      const input = e.target.closest(inputSelector);
      if (!input) return;

      spoilerHandle(input, true);
    });
  }
}

export {initSpoiler, initCheckSpoiler};
